import dayjs from "dayjs";
import { ONLY_DATE_FORMAT_FOR_SERVER } from "us.collection.economy/constants";
import { IGetPaymentsImportSummary } from "us.collection.economy/interfaces";

export function GetPaymentsImportSummary(this: any): IGetPaymentsImportSummary {
  const [startDate, endDate] = this.dateRange;
  return {
    startDate: dayjs(startDate)
      .startOf("day")
      .format(ONLY_DATE_FORMAT_FOR_SERVER),
    endDate: dayjs(endDate).endOf("day").format(ONLY_DATE_FORMAT_FOR_SERVER),
    fileName: this.fileName ?? "",
  };
}
